module.exports = __webpack_public_path__ + "static/media/logo-white.88080bea.svg";


//////////////////
// WEBPACK FOOTER
// ./src/js/assets/logos/logo-white.svg
// module id = 1759
// module chunks = 0